import { render, staticRenderFns } from "./AgentList.vue?vue&type=template&id=28645aa6&scoped=true"
import script from "./AgentList.vue?vue&type=script&lang=ts"
export * from "./AgentList.vue?vue&type=script&lang=ts"
import style0 from "./AgentList.vue?vue&type=style&index=0&id=28645aa6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28645aa6",
  null
  
)

export default component.exports